import * as z from 'zod/mini';
/**
 * Define a scalar, patient-reported measurement (the common case). One call yields the answer value
 * schema/shape, the ordered dropdown tokens, the conversion factors, the canonical unit and the LOINC
 * code, with the UCUM unit token literal union (`keyof TUnits`) inferred into all of them.
 *
 * The generic mirrors `defineUnit`'s `keyof TUnits` shape on purpose — a `const TUnit` generic in a
 * `Record<TUnit, number>` value position would infer `string` and collapse the literal union.
 *
 * @__NO_SIDE_EFFECTS__
 */
export function defineMeasurement(options) {
    const unitTokens = Object.keys(options.units);
    const valueNumber = options.min != null ? z.number().check(z.minimum(options.min)) : z.number();
    const unitEnum = z.enum(unitTokens);
    const valueShape = { value: valueNumber, unit: unitEnum };
    return {
        shape: 'scalar',
        label: options.label,
        unitLabel: options.unitLabel,
        loinc: options.loinc,
        units: options.units,
        unitTokens,
        canonical: options.canonical,
        step: options.step,
        min: options.min,
        valueShape,
        value: z.object(valueShape),
    };
}
//# sourceMappingURL=ScalarMeasurement.js.map